import { fetchPageContent } from "../../magnolia.service";
import { getDefaultLanguage } from "../../utils/languages";

export const FETCH_ROOT_PAGE = "FETCH_ROOT_PAGE";

export const fetchRootPage = (nodePath) => {
    return async (dispatch, getState) => {
        const defaultLanguageCode = getDefaultLanguage(getState().siteData);
        const payload = await fetchPageContent(nodePath, defaultLanguageCode);

        dispatch({
            type: FETCH_ROOT_PAGE,
            payload,
        });
    };
};
